import {Button, Spinner} from 'react-bootstrap'
import React, {MouseEventHandler, ReactNode} from 'react'

type Props = {
  type?: 'submit' | 'button' | 'reset' | undefined
  doing?: boolean
  disabled?: boolean
  variant?: string
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined
  icon?: string
  children?: ReactNode
}

const ButtonComp: React.FC<Props> = ({
  type = 'button',
  doing = false,
  disabled = false,
  variant = 'primary',
  icon,
  onClick,
  children,
}) => {
  return (
    <>
      <Button
        type={type}
        variant={variant}
        className='mx-2'
        disabled={doing || disabled}
        onClick={onClick}
      >
        {doing ? <Spinner animation='border' size='sm' /> : icon ? <i className={icon} /> : null}
        {children}
      </Button>
    </>
  )
}
export default ButtonComp
